// extracted by mini-css-extract-plugin
export default {"page":"HomePage_page__93z0s"};